const normalizeArray = (value) => (Array.isArray(value) ? value : []);

const normalizeAdd = (value) => {
  if (!value || typeof value !== 'object') return null;
  const label = typeof value.label === 'string' ? value.label : null;
  if (label === null) return null;
  const enabled = typeof value.enabled === 'boolean' ? value.enabled : false;
  return { label, enabled };
};

const normalizeRemove = (value) => {
  if (!value || typeof value !== 'object') return null;
  const fieldKey = typeof value.fieldKey === 'string' ? value.fieldKey : null;
  if (fieldKey === null) return null;
  return { fieldKey };
};

const normalizeUpdate = (value) => {
  if (!value || typeof value !== 'object') return null;
  const fieldKey = typeof value.fieldKey === 'string' ? value.fieldKey : null;
  const label = typeof value.label === 'string' ? value.label : null;
  if (fieldKey === null || label === null) return null;
  const enabled = typeof value.enabled === 'boolean' ? value.enabled : false;
  return { fieldKey, label, enabled };
};

export const normalizeCustomFieldConfigUpdates = (value) => {
  const adds = normalizeArray(value?.adds).map(normalizeAdd).filter(Boolean);
  const removes = normalizeArray(value?.removes).map(normalizeRemove).filter(Boolean);
  const updates = normalizeArray(value?.updates).map(normalizeUpdate).filter(Boolean);

  return {
    adds,
    removes,
    updates,
  };
};
